/**
 * Everything the legal pages state about the business, in one place.
 *
 * Two rules for this file:
 *
 * 1. The commercial figures must match what the checkout actually charges.
 *    The backend `config/commerce.php` is the source of truth; these mirror it
 *    for display. A policy that states a different shipping threshold than the
 *    one the customer is billed is a chargeback waiting to happen.
 *
 * 2. Anything marked TODO must be completed before these pages go live. They
 *    are deliberately conspicuous rather than plausible-looking defaults —
 *    publishing a confidently wrong governing law is worse than an obvious gap.
 */

export const LEGAL_ENTITY = {
  // TODO: registered legal name, e.g. "Guhso Media Ltd."
  name: 'Guhso',
  // TODO: full registered business address.
  address: '[TODO: registered business address]',
  // TODO: the jurisdiction whose law governs these terms and any dispute.
  jurisdiction: '[TODO: governing jurisdiction]',
  contactEmail: 'hello@guhso.com',
  privacyEmail: 'privacy@guhso.com',
  supportEmail: 'support@guhso.com',
  site: 'guhso.com',
};

/** Last substantive revision. Update when the text changes, not on redeploys. */
export const EFFECTIVE_DATE = 'August 6, 2026';

/** Mirrors guhso-backend/config/commerce.php. */
export const COMMERCE = {
  currency: 'USD',
  freeShippingThreshold: 50,
  /** Fallback rate, used only when a live carrier quote is unavailable. */
  flatShippingRate: 9.99,
  /** How much postage the business absorbs on a free-shipping order. */
  freeShippingAbsorbCap: 15,
  taxRate: 0.08,
  returnWindowDays: 30,
  defectReportDays: 7,
  refundBusinessDays: '5–10',
};

/** Mirrors config/services.php plan pricing. */
export const MEMBERSHIP = {
  monthly: 3.99,
  annual: 38.5,
  currency: 'USD',
};

export const money = (amount) =>
  `$${Number(amount).toFixed(2)}`;

export const percent = (rate) => `${(rate * 100).toFixed(0)}%`;
